/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyWithRelations } from './companyWithRelations';
import { TypeEventWithRelations } from './typeEventWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: EventWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EventWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    name: string;
    description?: string;
    dateStart: string;
    dateEnd?: string;
    publish?: boolean;
    frequency?: string;
    url?: string;
    typeEventId?: string;
    typeEvent?: TypeEventWithRelations;
    companies?: Array<CompanyWithRelations>;
    users?: Array<UserWithRelations>;
}

